import { createContext, useContext } from 'react';
import { globalStores } from 'src/js/store';

const storesContext = createContext(globalStores);

export const useStores = () => {
  return useContext(storesContext);
};
